import { Title } from '@angular/platform-browser';
import { Alert } from './../../classes/Alert';
import { NSValidation } from './../../classes/NSValidation';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
declare var bootbox:any;
declare var $:any;
@Component({
  selector: 'app-survey-questions-ne',
  template: require('./survey-questions-ne.component.html')
})
export class SurveyQuestionsNeComponent extends BaseComponent implements OnInit {
  
  public surveyId = -1;
  public survey = {
    title: ""
  };

  public groups = [
    {
      name: "Survey Question",
      value: "0"
    },
    {
      name: "Post Survey Questions (Mandatory)",
      value: "1"
    },
    {
      name: "Post Survey Questions (Optional)",
      value: "2"
    }
  ];

  public surveyQuestionOptionId = -1;
  public optionText = "";
  public optionTitle = "";
  public optionOrder = 10;

  public subcategories = [];

  public tipText = "";

  public question = {
    questionOrder:10,
    title:"",
    text:"",
    managerText: "",
    positiveText: "",
    negativeText: "",
    managerTitle:"",
    type:1,
    instructions:"",
    subCategoryId:-1,
    weight:1.0,
    optionSelectionMinLimit:null,
    optionSelectionMaxLimit:null,
    surveyQuestionOptions:null,
    surveyQuestionTips:[],
    groupValue: 0,
    groupInstructions: "",
    orderingAllowed: false,
    allowComment:0
  };

  public questionId = -1;

  ngOnInit() {
    super.ngOnInit();
    this.loadSubCategories();

    setTimeout(()=>{    //<<<---    using ()=> syntax
      var that = this;
      $(function(){

        $('#tipText').summernote({
          callbacks: {
            onChange: function(contents, $editable) {
              that.tipText = contents;
              console.log('onChange:', contents, $editable);
            }
          },
          toolbar: [
            // [groupName, [list of button]]
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['fontsize', ['fontsize']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['height', ['height']]
          ]
        });
  
      });
    },1000);

    


  }

  routeParamsUpdated() {
    this.surveyId = this.currentRouteParams["surveyId"];
    this.questionId = this.currentRouteParams["qId"];
    this.loadSurveyById();
    if(this.questionId>0)
      this.loadQuestionById();
    else
      this.questionId = -1;
  }

  public loadQuestionById() {
    this.busy = this.lsApi.getSurveyQuestionById(this.questionId).subscribe(resp => {
      if(resp.status) {
          console.log(resp.data[0]);
          this.question = resp.data[0];
      }
    },
    error => {
        console.log(error);
    });
  }

  public loadSubCategories() {
    this.busy = this.lsApi.getSubCategories().subscribe(resp => {
        if(resp.status) {
            this.subcategories = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }

  public loadSurveyById() {
    this.busy = this.lsApi.getSurveyById(this.surveyId).subscribe(resp => {
        if(resp.status) {
            this.survey = resp.data[0];
        }
    },
    error => {
        console.log(error);
    });
  }

  public deleteTip(tip, index) {

    bootbox.confirm({message:"Do you want to delete tip #" + (index + 1) + "?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {
          
          this.question.surveyQuestionTips.splice(index,1);
          this.newTip();

        }
      }});

  }

  public editTip(tip, index) {
    this.tipIndex = index;
    this.tipText = tip.richText;
    this.surveyQuestionTipId = tip.surveyQuestionTipId;
    $("#tipText").summernote('code',this.tipText);
  }

  public newTip() {
    this.tipText = "";
    this.tipIndex = -1;
    this.surveyQuestionTipId = -1;
    $("#tipText").summernote('code',"");
    $("#tipText").focus();
  }

  public previewTipWindow = null;
  public previewTipWindow_Tip1 = null;
  public previewTipWindow_Tip2 = null;
  public previewTipWindow_Tip3 = null;

  public updateTipPreview() {

    if(this.previewTipWindow!=null) {
      if(this.previewTipWindow_Tip1 != null && this.previewTipWindow_Tip2 != null && this.previewTipWindow_Tip3 != null) {

        this.previewTipWindow_Tip1.innerHTML = "N/A";
        this.previewTipWindow_Tip2.innerHTML = "N/A";
        this.previewTipWindow_Tip3.innerHTML = "N/A";
        
        if(this.question.surveyQuestionTips.length > 0) {
          var tip = this.question.surveyQuestionTips[0];
          this.previewTipWindow_Tip1.innerHTML = tip.richText;
        }
        if(this.question.surveyQuestionTips.length > 1) {
          var tip = this.question.surveyQuestionTips[1];
          this.previewTipWindow_Tip2.innerHTML = tip.richText;
        }
        if(this.question.surveyQuestionTips.length > 2) {
          var tip = this.question.surveyQuestionTips[2];
          this.previewTipWindow_Tip3.innerHTML = tip.richText;
        }
      }
    }

  }
  
  public previewTips() {
    var that = this;
    this.previewTipWindow = window.open('/survey/preview-tips','popupWin','width=800,height=650');
    this.previewTipWindow.addEventListener('load', function(){
      that.previewTipWindow_Tip1 = that.previewTipWindow.document.getElementById("tip1");
      that.previewTipWindow_Tip2 = that.previewTipWindow.document.getElementById("tip2");
      that.previewTipWindow_Tip3 = that.previewTipWindow.document.getElementById("tip3");

      that.updateTipPreview();
    }, true); 
    
    //this.previewTipWindow.document.writeln('<html><head><title>test</title></head><body><form><input type="text" id="popupTextBox"/></form></body></html>');
    //this.previewTipWindow.document.close();
    //parentText = document.getElementById("parentTextBox");
    //transferText();
  }

  public surveyQuestionTipId = -1;
  public tipIndex = -1;

  public saveTip() {
      if(this.tipText=="") {
          bootbox.alert("Please provide some text for this tip");
          return;
      }
    var tip = {
        surveyQuestionTipId: this.surveyQuestionTipId,
        surveyQuestionId: this.questionId,
        richText: ""
    };
    tip.richText = this.tipText;
    if(this.question.surveyQuestionTips==null) {
      this.question.surveyQuestionTips = [];
    }
    if(this.tipIndex==-1)
      this.question.surveyQuestionTips.push(tip);
      else {
          this.question.surveyQuestionTips[this.tipIndex] = tip;
      }
      this.updateTipPreview();
    this.newTip();
  }

  public editOption(option, index) {
    this.optionIndex = index;
    this.optionText = option.optionText;
    this.optionTitle = option.title;
    this.optionOrder = option.optionOrder; 
    this.surveyQuestionOptionId = option.surveyQuestionOptionId;
  }

  public deleteOption() {
    if(this.optionIndex==-1) {
      return;
    }
    else{
      this.question.surveyQuestionOptions.splice(this.optionIndex,1);
      this.newOption();
    }
  }

  public optionIndex = -1;

  public newOption() {
      this.optionText = "";
      this.optionTitle = "";
      this.optionOrder = 10;
      this.optionIndex = -1;
      this.surveyQuestionOptionId = -1;
      $("#optTitle").focus();
  }

  public clearOptions() {
    this.question.surveyQuestionOptions = [];
  }

  public addLinearOptions() {
    for(var i=0;i<10;i++) {
      var option = {
        surveyQuestionId: this.questionId,
        surveyQuestionOptionId: this.surveyQuestionOptionId,
        optionText: i+1,
        optionOrder: i,
        title: i == 0 ? "(never)" : i == 9 ? "(all the time)" : ""
      };
      if(this.question.surveyQuestionOptions==null) {
        this.question.surveyQuestionOptions = [];
      }
      this.question.surveyQuestionOptions.push(option);
    }
  }

  public addLinearOptionsPFB() {
    for(var i=0;i<5;i++) {
      var option = {
        surveyQuestionId: this.questionId,
        surveyQuestionOptionId: this.surveyQuestionOptionId,
        optionText: i+1,
        optionOrder: i,
        title: i == 0 ? "(strongly disagree)" : i == 4 ? "(strongly agree)" : ""
      };
      if(this.question.surveyQuestionOptions==null) {
        this.question.surveyQuestionOptions = [];
      }
      this.question.surveyQuestionOptions.push(option);
    }
    var option1 = {
      surveyQuestionId: this.questionId,
      surveyQuestionOptionId: this.surveyQuestionOptionId,
      optionText: "Don’t know / Doesn’t apply",
      optionOrder: i,
      title: ""
    };
    this.question.surveyQuestionOptions.push(option1);
  }
  public addRegulationOptions() {
    var optTexts = [
      "Strongly disagree","Somewhat disagree","Neutral","Somewhat agree","Strongly agree"
    ];
    var options = optTexts.map(x => { return {
      surveyQuestionId: this.questionId,
      surveyQuestionOptionId: this.surveyQuestionOptionId,
      optionText: x,
      optionOrder: 0,
      title: ""
    }});
    if(this.question.surveyQuestionOptions==null) {
      this.question.surveyQuestionOptions = [];
    }
    this.question.surveyQuestionOptions = options;
  }

  public addWantGritOptions() {
    var optTexts = [
      "Very much like me",
      "Mostly like me",
      "Somewhat like me",
      "Not much like me",
      "Not like me at all"
    ];
    var options = optTexts.map(x => { return {
      surveyQuestionId: this.questionId,
      surveyQuestionOptionId: this.surveyQuestionOptionId,
      optionText: x,
      optionOrder: 0,
      title: ""
    }});
    if(this.question.surveyQuestionOptions==null) {
      this.question.surveyQuestionOptions = [];
    }
    this.question.surveyQuestionOptions = options;
  }

  public saveOption() {
    if(this.optionText=="") {
        bootbox.alert("Please provide some text for this option");
        return;
    }
      var option = {
          surveyQuestionId: this.questionId,
          surveyQuestionOptionId: this.surveyQuestionOptionId,
          optionText: "",
          title: "",
          optionOrder: 0
      };
      option.title = this.optionTitle;
      option.optionText = this.optionText;
      var order = isNaN(parseInt(this.optionOrder + ""));
      if(!order)
        option.optionOrder = this.optionOrder;
      if(this.question.surveyQuestionOptions==null) {
        this.question.surveyQuestionOptions = [];
      }
      if(this.optionIndex==-1)
        this.question.surveyQuestionOptions.push(option);
        else {
            this.question.surveyQuestionOptions[this.optionIndex] = option;
        }
    this.newOption();
  }

  public save() {
    var validate:NSValidation = new NSValidation();

    var errorMessage = "";
    if(validate.isEmpty(this.question.text)) {
        errorMessage = "Please provide some text for the question";
    }
    else if(this.question.subCategoryId==null || this.question.subCategoryId <=0 ) {
        errorMessage = "Please select a sub-category";
    }
    else if(this.question.weight==null || this.question.weight <=0 ) {
        errorMessage = "Please provide a weight for this question";
    }
    
    if(this.question.type==0 || this.question.type==2) {
        if(this.question.surveyQuestionOptions == null || this.question.surveyQuestionOptions.length<=0) {
            errorMessage = "Please provide options for this question type.";
        }
        
        if(this.question.type==2) {
            if(this.question.optionSelectionMinLimit==null || this.question.optionSelectionMinLimit=="") {
                errorMessage = "Please provide a 'Min Select Limit'.";
            }
            else if(this.question.optionSelectionMinLimit==null || this.question.optionSelectionMinLimit=="") {
                errorMessage = "Please provide a 'Max Select Limit'.";
            }
        }
    }

    if(errorMessage!="") {
        bootbox.alert(errorMessage);
    }
    else {
        var minLimit = this.question.optionSelectionMinLimit;
        var maxLimit = this.question.optionSelectionMaxLimit;

        var opts = null;

        if(this.question.type!=2) {
            minLimit = null;
            maxLimit = null;
        }
        else {
            if(minLimit>maxLimit) {
                bootbox.alert("Please ensure 'Min Select Limit' is less than or equal to 'Max Select Limit'");
                return;
            }
            else if(minLimit == 0 || maxLimit == 0 || minLimit == "" || maxLimit == "") {
                bootbox.alert("Please ensure 'Min Select Limit' and/or 'Max Select Limit' is greater than 0");
                return;
            } 
        }
        if(this.question.type==1)
          this.question.allowComment = 0;
        if(this.question.type!=1) {
            // Some Options Required
            opts = JSON.stringify(this.question.surveyQuestionOptions);
        }
        var tips = JSON.stringify(this.question.surveyQuestionTips);
        this.busy = this.lsApi.saveQuestion(this.questionId, this.surveyId, this.question.questionOrder, this.question.title, this.question.managerTitle,
          this.question.text, this.question.managerText, this.question.positiveText, this.question.negativeText, this.question.weight, this.question.subCategoryId,
          this.question.instructions, this.question.type, minLimit, maxLimit, opts, tips, this.question.groupValue, this.question.groupInstructions, this.question.orderingAllowed ? 1 : 0, this.question.allowComment ? 1 : 0).subscribe(resp => {
            if(resp.status) {
                this.router.navigate(['/admin/surveys',this.surveyId,'questions']).then(() => {
                  this.appToast.success("Question Successfully Saved","Question Saved")
                })
            }
        },
        error => {
            console.log(error);
        });
    }
  }

  public cancel() {
    this.router.navigate(['/admin/surveys',this.surveyId,'questions']);
  }

  public delete() {

    bootbox.confirm({message:"Do you want to delete '" + this.question.title + "' question and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteQuestionById(this.questionId).subscribe(resp => {
              if(resp.status) {
                  this.router.navigate(['/admin/surveys',this.surveyId,'questions']).then(() => {
                    this.appToast.success("Question Successfully Deleted","Question Deleted")
                  })
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }






}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/survey-questions-ne/survey-questions-ne.component.ts